import { useEffect, useState } from "react";
import { PageHeader, Section } from "@/components/layout/Section";
import { IMAGES } from "@/constants/branding";
import api from "@/lib/api";
import { motion } from "framer-motion";

const fallbackImages = [IMAGES.worship, IMAGES.community, IMAGES.bible, IMAGES.crowd, IMAGES.prayer, IMAGES.hands];

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setItems(r.data));
  }, []);

  const shown = items.length ? items : fallbackImages.map((img, i) => ({ id: `f-${i}`, image: img, title: null }));

  return (
    <div data-testid="gallery-page">
      <PageHeader
        kicker="Gallery"
        title="Moments of glory."
        subtitle="A visual journey through worship, fellowship, and Kingdom moments in our house."
      />
      <Section>
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [column-fill:_balance]">
          {shown.map((g, i) => (
            <motion.figure
              key={g.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.05 }}
              className="mb-5 break-inside-avoid rounded-2xl overflow-hidden card-soft"
              data-testid={`gallery-item-${i}`}
            >
              <img src={g.image} alt={g.title || "Gallery image"} className="w-full h-auto object-cover" loading="lazy" />
              {g.title && <figcaption className="p-4 text-sm text-slate-600">{g.title}</figcaption>}
            </motion.figure>
          ))}
        </div>
      </Section>
    </div>
  );
}
